export var RuleType;
(function (RuleType) {
    RuleType["Accessibility"] = "accessibility-rule";
    RuleType["Functional"] = "functional-rule";
    RuleType["Resource"] = "resource-rule";
    RuleType["Webform"] = "webform-rule";
    RuleType["Link"] = "link-rule";
    RuleType["Spellcheck"] = "spellcheck-rule";
    RuleType["Performance"] = "performance-rule";
    RuleType["Readability"] = "readability-rule";
    RuleType["Security"] = "security-rule";
})(RuleType || (RuleType = {}));
/**
 * Duplicate enum of ResultType.
 * @deprecated
 */
export var RuleResultOutcome;
(function (RuleResultOutcome) {
    RuleResultOutcome["failed"] = "failed";
    RuleResultOutcome["success"] = "success";
    RuleResultOutcome["unverified"] = "unverified";
    RuleResultOutcome["maybe"] = "maybe";
})(RuleResultOutcome || (RuleResultOutcome = {}));
/**
 * Outcome of an evaluated rule.
 */
export var ResultType;
(function (ResultType) {
    ResultType["Passed"] = "Passed";
    ResultType["Failed"] = "Failed";
    ResultType["Warning"] = "Warning";
    ResultType["Unverified"] = "Unverified";
})(ResultType || (ResultType = {}));
/**
 * Significance of an error.
 */
export var Severity;
(function (Severity) {
    Severity["Comment"] = "comment";
    Severity["Minor"] = "minor";
    Severity["Major"] = "major";
    Severity["Severe"] = "severe";
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
//# sourceMappingURL=types.js.map